import { Component, inject } from '@angular/core';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: false,
  template: `
    <router-outlet />
    <app-toast-stack />
    <app-brand-loader [message]="auth.ready() ? null : 'Cargando tu consola…'" />
  `,
})
export class App {
  readonly auth = inject(AuthService);
}
